import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import { supplyCategories } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/links";

export default function SupplySection() {
  return (
    <section id="insumos" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-24 top-24 h-[380px] w-[380px] rounded-full glow-beige blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-10 h-[320px] w-[320px] rounded-full glow-clinic blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Unidad 04 · ALÉA Pro Supply</Eyebrow>
              <h2 className="mt-3 font-heading text-4xl font-bold leading-[1.05] text-foreground-950 md:text-5xl">
                Insumos para cabinas y clínicas
              </h2>
              <p className="mt-5 max-w-md text-[15px] leading-relaxed text-foreground-600">
                Surtimos productos por volumen, consumibles y aparatología para cosmetólogas, spas y
                clínicas. Compra por unidad o por mayoreo, con asesoría real.
              </p>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <a
                  href={buildWhatsAppLink("Hola ALÉA, quiero cotizar insumos para mi cabina.")}
                  target="_blank"
                  rel="noreferrer"
                  className="cta-primary inline-flex min-h-[48px] items-center justify-center gap-2 whitespace-nowrap rounded-[16px] bg-primary-500 px-5 font-label text-[11px] font-semibold uppercase tracking-[0.14em] text-background-50 transition-all duration-300 hover:bg-primary-600"
                >
                  Cotizar insumos
                </a>
                <a
                  href={buildWhatsAppLink("Hola ALÉA, quiero solicitar la lista de insumos profesionales.")}
                  target="_blank"
                  rel="noreferrer"
                  className="cta-outline inline-flex min-h-[48px] items-center justify-center gap-2 whitespace-nowrap rounded-[16px] border border-secondary-300 bg-background-50 px-5 font-label text-[11px] font-semibold uppercase tracking-[0.14em] text-foreground-950 transition-all duration-300 hover:border-accent-400"
                >
                  <i className="ri-whatsapp-line text-base" />
                  Solicitar lista
                </a>
              </div>
            </Reveal>

            <Reveal delay={140} className="mt-10 hidden lg:block">
              <div className="card-soft h-[340px] w-full overflow-hidden rounded-[28px] bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Bright%20clean%20flat%20lay%20of%20professional%20aesthetic%20clinic%20supplies%20with%20neutral%20packaging%20bottles%2C%20gloves%20and%20stainless%20instruments%20on%20a%20white%20surface%2C%20modern%20minimal%20editorial%20still%20life%2C%20soft%20natural%20light%2C%20no%20text&width=1000&height=1100&seq=aleaW-supply&orientation=portrait&nocache=true"
                  alt="Insumos profesionales ALÉA Pro Supply para cabinas y clínicas"
                  title="Insumos profesionales estética ALÉA Pro Supply Culiacán"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-7">
            {supplyCategories.map((category, index) => (
              <Reveal
                key={category.name}
                delay={(index % 2) * 80}
                className="card-soft group relative overflow-hidden rounded-[24px] border border-secondary-200 bg-background-50 p-6 transition-all duration-500 hover:-translate-y-1 hover:card-premium md:p-7"
              >
                <span className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-accent-400 to-accent-700" />
                <span className="flex h-12 w-12 items-center justify-center rounded-[14px] border border-accent-200 bg-accent-50 text-accent-700">
                  <i className={`${category.icon} text-xl`} />
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold leading-snug text-foreground-950">
                  {category.name}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{category.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}